module.exports = __webpack_public_path__ + "img/pit_fight_roadmap.51f12037.jpg";